import PropTypes from 'prop-types';
import { Button, Typography, ModalBody } from '@visionplanner/ui-react-material';

/** Component used to display welcome and thank you
 * screens with custom button texts and images.
 */

const OnBoardGreeting = ({
  dataTa,
  onClick,
  buttonLabel,
  imageUrl,
  alt,
  title,
  description,
}) => (
  <ModalBody>
    <div className="flex-column align-items-center align-self-center flex-relative-size-one pad-md">
      <Typography use="h1" className="mar-b-xl">{title}</Typography>
      <img src={imageUrl} alt={alt} className="mar-b-xl" />
      <Typography use="normal-text" className="text-align-center mar-b-xl">{description}</Typography>
      <Button dataTa={dataTa} className="mar-b-xl" onClick={onClick}>{buttonLabel}</Button>
    </div>
  </ModalBody>
);

OnBoardGreeting.propTypes = {
  /** attribute value of the custom data-ta attribute that can be used to locate a specific element for testing purposes */
  dataTa: PropTypes.string,
  /** Callback handler */
  onClick: PropTypes.func,
  /** Label to the button */
  buttonLabel: PropTypes.string,
  /** Image url */
  imageUrl: PropTypes.string,
  alt: PropTypes.string,
  /** Custom title */
  title: PropTypes.string,
  /** Custom description */
  description: PropTypes.string,
};

export default OnBoardGreeting;
